import React from "react";
import { Button, Typography } from "@material-ui/core";
import BackIcon from "@material-ui/icons/ChevronLeft";
import SupportIcon from "@material-ui/icons/EmailOutlined";
import WarningIcon from "@material-ui/icons/Warning";

import IntellipayLogo from "../images/intellipay-dark.png";

const NotAuthorized = (props) => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <WarningIcon style={{ fontSize: "8em", marginBottom: 40 }} />
        <Typography
          variant="h4"
          style={{ marginBottom: 25, textAlign: "center", fontSize: "1.5em" }}
        >
          <x-lang>You are not authorzied to view this page</x-lang>
        </Typography>
        <Typography variant="body1" style={{ textAlign: "center" }}>
        <x-lang>If you'd like to go back and try again, please select the "Back"
          button below. If you would like to contact customer support, please
          select the "Contact Support" button.</x-lang>
        </Typography>
        <div style={{ marginTop: 40 }}>
          <Button
            variant="contained"
            startIcon={<BackIcon />}
            style={{ marginRight: 15 }}
            onClick={() => window.history.back()}
          >
            <x-lang>Back</x-lang>
          </Button>
          <Button
            variant="contained"
            startIcon={<SupportIcon />}
            style={{ background: "#149EDB", color: "white" }}
            onClick={() =>
              window.open("http://www.convenientpayments.com/contact/")
            }
          >
            <x-lang>Contact Support</x-lang>
          </Button>
        </div>
        <Typography variant="subtitle1" style={{ marginTop: 40 }}>
        <x-lang>Powered by</x-lang>
        </Typography>
        <img src={IntellipayLogo} height={50} />
      </div>
    </div>
  );
};

export default NotAuthorized;

const styles = {
  container: {
    display: "flex",

    justifyContent: "center",
    width: "100vw",
    height: "100vh",
  },
  content: {
    display: "flex",
    padding: 15,
    flexDirection: "column",
    width: 800,
    alignItems: "center",
  },
};
